import * as React from 'react';
import { Accordion, Card, Button } from 'react-bootstrap';
import { IsJsonString } from "../../../../services/Utils/StringUtils";
import * as linkify from 'linkifyjs';
import { IAppRouteLocation } from "../../../../common/sharedTypes";
import * as urls from '../../../shared/urls';
import { FormSaveStatus } from '../../../../services/Enums/shared';

interface IFormIOImportProps {
  history:any;
}

enum ImportType {
  URL,
  JSON
}

export default class FormIOImport extends React.Component<IFormIOImportProps> {
  importUrl = React.createRef<HTMLInputElement>();
  importJSON = React.createRef<HTMLTextAreaElement>();
  

  handleImport = (type:ImportType) => {
    let location:IAppRouteLocation = {
      pathname:"/CreateForm"
    };

    let locationState:any = {};

    if (type == ImportType.URL) {
      if (this.importUrl.current.value.trim() != "") {
        // Using Linkify for URL validation
        let links = linkify.find(this.importUrl.current.value.trim());
        if (links[0].type=="url") {
          locationState.formURL = links[0].href;
        }
      }
    } else {
      // Import from JSON
      if (this.importJSON.current.value.trim() != "" && IsJsonString(this.importJSON.current.value.trim())) {
        locationState.formJSON = this.importJSON.current.value.trim();
      }
    }

    location.state = locationState;
    this.props.history.push(location);
  }


  render() {
    return (
      <div className="formImporter">
        <h3 className="formHeader">Import Form</h3>
        <Accordion defaultActiveKey="0">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              Import Form from URL
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <input type="url" className="formImportUrl" placeholder="https://lexisnexis.form.io/{my-new-form}" ref={this.importUrl} />
                <Button onClick={() => this.handleImport(ImportType.URL)}>Import</Button>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="1">
              Import Form with JSON
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <textarea cols={50} rows={25} ref={this.importJSON} className="formImportJson"></textarea>
                <Button onClick={() => this.handleImport(ImportType.JSON)}>Import</Button>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}
